import { render, staticRenderFns } from "./GlobalButton.vue?vue&type=template&id=e6d5ed94&scoped=true&"
import script from "./GlobalButton.vue?vue&type=script&lang=js&"
export * from "./GlobalButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6d5ed94",
  null
  
)

export default component.exports